import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  lightTrigger: {
    backgroundColor: palette.shades[100],
    '& path': {
      fill: palette.shades[700]
    },
    '&:hover': {
      backgroundColor: palette.shades[100],
      '& path': {
        fill: palette.shades[800]
      }
    }
  },
  occupancyTrigger: {
    marginRight: '4px'
  }
});
export default useStyles;